export const formatDate = (iso?: string) =>
  iso ? new Date(iso).toLocaleString('fr-FR') : '';

const currencyFormatter = (() => {
  try {
    return new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: 'MAD',
      minimumFractionDigits: 2,
    });
  } catch (error) {
    console.warn('Currency formatter unavailable', error);
    return null;
  }
})();

export const formatPrice = (value?: number) => {
  if (typeof value !== 'number' || !Number.isFinite(value)) {
    return '';
  }
  if (currencyFormatter) {
    return currencyFormatter.format(value);
  }
  return `${value.toFixed(2)} MAD`;
};

export const parsePrice = (value: unknown): number | undefined => {
  if (value === null || value === undefined) {
    return undefined;
  }

  if (typeof value === 'number') {
    return Number.isFinite(value) ? value : undefined;
  }

  if (typeof value === 'string') {
    const normalized = value.replace(/\s+/g, '').replace(',', '.');
    if (!normalized) {
      return undefined;
    }
    const parsed = Number(normalized);
    return Number.isFinite(parsed) ? parsed : undefined;
  }

  return undefined;
};
